import React from 'react';
import styled from 'styled-components';

const StyledLogoImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;

  border: none;
  margin: 0;
  padding: 0;
`;

export interface IHeaderThemeLogoProps {
  src?: string | undefined;
  alt?: string | undefined;
}
/**
 * Logo principale dell'applicativo.
 */
export function HeaderThemeLogo(props: IHeaderThemeLogoProps) {
  return <StyledLogoImg {...props} />;
}
